<template>
  <div class="text-xs-center">
    <v-tooltip bottom>
      <span slot="activator">
        <v-chip :color="currentImportance.color" text-color="white">{{currentImportance.value}}</v-chip>
      </span>
      <span>{{currentImportance.description}}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { Importance } from "@/datatypes/Importance";
export default {
  data: () => ({}),
  props: {
    currentImportance: {
      type: Importance,
      default: () => {
        return new Importance();
      }
    }
  }
};
</script>
